













































































































import Vue from "vue";
import WatchListItem from "./WatchListItem.vue";
import Dropdown from "@/components/dropdown/DropDown.vue";
import { UseEntitiesDropDown } from "@/common/composition/entities-dropdown";
import { POPULATION_TYPE } from "@/common/models";
import { state } from "@/views/investigation/data/state";
import { computed, ref } from "@vue/composition-api";
import { Investigation } from "@/views/investigation/data/models";
import { ICONS } from "@/common/icons.map";
import isEmpty from "lodash.isempty";
import { UseModal } from "@/components/root/modal";
import { AppAnalytics } from "@/analytics";
import ThemeImg from "@/components/ThemeImg.vue";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Dropdown,
    WatchListItem,
    ThemeImg,
  },
  setup() {
    const {
      investigations,
      setCurrentInvestigation,
      deleteInvestigation,
    } = state;
    const {
      entitiesType,
      onEntityTypeChanged,
      selectedEntityType,
      selectedType,
    } = UseEntitiesDropDown({
      entities: [
        POPULATION_TYPE.EMPLOYEE,
        POPULATION_TYPE.ORGANIZATION,
        POPULATION_TYPE.CONTACT,
        POPULATION_TYPE.PRIVATE_EMAIL,
        POPULATION_TYPE.FOLDER,
        POPULATION_TYPE.FILE,
        POPULATION_TYPE.LABEL,
      ],
      onChange: (item) => {
        /*  */
      },
      all: true,
    });

    const selectedListItemId = ref("");
    const is_selected_item_not_owned = computed(() => {
      if (!selectedListItemId.value) {
        return false;
      }
      const investigation = investigations.value.find(
        (inv) => inv.id === selectedListItemId.value
      );
      return !investigation?.owned;
    });

    const watchList = computed(() =>
      (investigations.value as Investigation[])
        .filter((inv) => {
          if (selectedEntityType.value[0]?.id === POPULATION_TYPE.ALL) {
            return true;
          }
          return inv.type === selectedType.value;
        })
        .map((inv) => {
          return {
            id: inv.id,
            name: inv.name,
            icon: ICONS.ENTITIES.get(inv.type),
            shared: inv.shared,
          };
        })
    );

    const goToItem = () => {
      AppAnalytics.report({
        component: "Investigation",
        eventName: "Watchlist[Action:Review]",
      });
      if (isEmpty(selectedListItemId.value)) {
        return;
      }
      const investigation = investigations.value.find(
        (inv) => inv.id === selectedListItemId.value
      );
      if (investigation) {
        setCurrentInvestigation(investigation);
        SharedState.investigation.investigate({
          ...investigation,
          id: investigation.objectId,
        });
      }
    };

    const removeFromList = async () => {
      AppAnalytics.report({
        component: "Investigation",
        eventName: "Watchlist[Action:Remove]",
      });
      if (isEmpty(selectedListItemId.value)) {
        return;
      }
      const investigation = investigations.value.find(
        (inv) => inv.id === selectedListItemId.value
      );
      if (investigation) {
        const res = await UseModal().showSimple({
          title: "Remove from watchlist",
          desc: "Are you sure?",
          submitBtnText: "Remove",
          cancelBtnText: "Cancel",
        });
        if (res.type === "success") {
          await deleteInvestigation(investigation);
          selectedListItemId.value = "";
        }
      }
    };

    const onCheckChanged = (id: string) => {
      selectedListItemId.value = id;
    };

    return {
      selectedListItemId,
      is_selected_item_not_owned,
      entitiesType,
      onEntityTypeChanged,
      selectedEntityType,
      selectedType,
      watchList,
      goToItem,
      investigations,
      removeFromList,
      onCheckChanged,
    };
  },
});
